
import { livestart, share } from '@/api';
import router from '@/router';
import store from '@/store';
import { useI18n } from '@/utils/i18n';
import dayjs from 'dayjs';
import { computed, defineComponent, onUpdated, ref, watch } from "vue";
import { onBeforeRouteLeave } from 'vue-router';

export default defineComponent({
  props:{
    info: Object
  },
  setup(props) {
    const lan: any = useI18n();
    console.log(props.info);
    function bianji(){
      if(props.info != undefined){
        router.push("/mine/webcast?id=" + props.info.liveid)
      }
    }
    // todo 修改后报错
    function kaishi(){
      if(props.info != undefined){
        const id = props.info.liveid;
        livestart(id).then(()=>{
            router.push("/live/liveing?id=" + id)
        })
      }
    }
    const time = ref(new Date().getTime())
    let play: any;
    const isvideo = ref(true);
    const fxtc = ref(false)
    watch(()=> props.info,()=>{
      if(props.info){
        console.log(props.info)

          if(props.info.fileid != '' || props.info.vodid != ''){
            play = window.TCPlayer('a' + time.value, { 
                fileID: (props.info.livestatus == 0 ? props.info.fileid : props.info.vodid),
                appID: '1303872925' 
            });
          }else{
            isvideo.value = false;
          }
          
        }
    })
    onBeforeRouteLeave((to, from, next) => {
      console.log(121)
      if(play){
        play.dispose()
      }
        next()
    })
            function fx(index: number){
            console.log(index)
            share().then((res: any)=>{
                console.log(res)
                let url = "";
                if(index == 1){
                    url = `https://service.weibo.com/share/share.php?url=${res.shareUrl}&appkey=2754574056&language=zh_cn&pic=${res.shareImg}&searchPic=true&title=${res.shareTitle}`
                }else {
                    url = `https://www.facebook.com/sharer.php?t=${encodeURIComponent(res.shareTitle)}&u=${res.shareUrl}`
                }
                window.open(url, "_blank")
            })
        }
        function show(){
            fxtc.value = true
        }
    // const liveinfo = ref(props.liveinfo)
    const zid = computed(()=>store.state.userinfo.zoneValue)
    const timestart = computed(()=>{
      /* eslint-disable */
       const utc = require('dayjs/plugin/utc') // dependent on utc plugin
      /* eslint-disable */
      const timezone = require('dayjs/plugin/timezone')
      dayjs.extend(utc)
      dayjs.extend(timezone)
      const days: any = dayjs;
      if(zid.value != ""){
        const now = days().tz(zid.value).unix();
        let dateline: string;
        if(props.info){
          dateline = props.info.dateline
          const start = days(dateline).unix()
          if(start - now < 15 * 60){
            return true;
          }else {
            return false;
          }

        }
      }
      return false;
    })
    return {
      bianji,
      kaishi,
      lan,
      time,
      isvideo,
      fx,
      fxtc,
      show,
      modalNode: () => document.getElementsByClassName("modal-container")[0],
      timestart
    }
  }
});
